var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_21851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C8.95385 40 0 31.0462 0 20C0 8.95385 8.95385 0 20 0C31.0462 0 40 8.95385 40 20C40 31.0462 31.0462 40 20 40ZM20 2.5C11.5046 2.5 2.5 11.0046 2.5 19.5C2.5 27.9954 11.4708 37.5 19.9662 37.5C28.4631 37.5 37.5 28.4954 37.5 20C37.5 11.5046 28.4969 2.5 20 2.5ZM26.98 25.4385L25.42 26.9985C25.1338 27.2846 24.6692 27.2846 24.3815 26.9985L19.9662 22.5831L15.5508 26.9985C15.2631 27.2846 14.8 27.2846 14.5123 26.9985L12.9523 25.4385C12.6662 25.1523 12.6662 24.6877 12.9523 24.4L17.3692 19.9862L12.9523 15.5708C12.6662 15.2831 12.6662 14.8185 12.9523 14.5308L14.5123 12.9723C14.8 12.6846 15.2631 12.6846 15.5508 12.9723L19.9662 17.3877L24.3815 12.9723C24.6692 12.6846 25.1338 12.6846 25.42 12.9723L26.98 14.5308C27.2662 14.8185 27.2662 15.2831 26.98 15.5708L22.5631 19.9862L26.98 24.4C27.2662 24.6877 27.2662 25.1538 26.98 25.4385Z",
    fill: "#FC5A5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_21851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/Reject.007cc3a88f2977cd7b80f616e8d63e1d.svg";
export { ForwardRef as ReactComponent };